const safeGetPathname = url => {
  try {
    return new URL(url).pathname;
  } catch (_unused) {
    // ignore
  }
  return url;
};
export const isActive = (item, selectedId) => {
  const pathname = window.location.pathname;
  if (item.loading) return false;
  if (selectedId) {
    return item.id === selectedId || item.key === selectedId;
  }
  if (!item.url) return false;
  return pathname.startsWith(safeGetPathname(item.url));
};
//# sourceMappingURL=isActive.js.map